module.exports = __webpack_public_path__ + "fonts/carton-slab-webfont.9ed39edf.eot";